import { useTranslation } from "react-i18next";
import { Service } from "@dreamhub/designsystem/icons";
import Text from "@/components/ui/text";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import ExportMenu from "@/components/ui/export-menu";
import ServicesTable from "@/components/layouts/ServicesTable/ServicesTable";
import { UserData } from "@/entities/users/types";
import { useExportButtonState } from "@/services/hooks/entities/useExportButtonState";

interface Props {
  userData: UserData;
}

const Services: React.FC<Props> = () => {
  const { t } = useTranslation();
  const {
    exportTo: exportServices,
    isExporting: isExportingServices,
    handleExportStateChange
  } = useExportButtonState();

  return (
    <div
      data-test="services-content"
      className="flex flex-col max-h-[calc(var(--app-content-h)-var(--table-bottom-space))] h-full"
    >
      <div
        data-test="services-header"
        className="flex justify-between p-4 pb-2 h-14"
      >
        <div
          data-test="services-title"
          className="flex items-center gap-[10px]"
        >
          <LogoIconContainer
            icon={<Service />}
            index={-1}
            className="size-8 flex-shrink-0"
            iconSize="5"
          />
          <Text as="div" variant="lgSubtitleH1" className="p-1">
            {t("services.title")}
          </Text>
        </div>
        <ExportMenu
          label={t("export")}
          data-test="services-export-button"
          onExport={exportServices}
          isExporting={isExportingServices}
        />
      </div>
      <ServicesTable onExportStateChange={handleExportStateChange} />
    </div>
  );
};

export default Services;
